import { render, staticRenderFns } from "./rightButtonMenu.html?vue&type=template&id=d6c8ed64&"
import script from "./rightButtonMenu.vue?vue&type=script&lang=js&"
export * from "./rightButtonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports